import { call, put, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import {
  previewFileClosed,
  selectContentLibraryOpenedFile,
  selectPreviewedFile,
} from 'features/content-library/contentLibrarySlice';
import { contentLibraryFileOpenRequested } from 'features/content-library/actions';
import { ContentLibraryOpenedFile } from 'features/content-library/types';

export function* openContentLibraryFileSaga(
  action: ReturnType<typeof contentLibraryFileOpenRequested>
) {
  const { id, personal } = action.payload;

  const openedFile: ReturnType<typeof selectContentLibraryOpenedFile> = yield select(
    selectContentLibraryOpenedFile
  );

  if (id === openedFile?.id) {
    const previewedFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);

    if (id === previewedFile?.id) {
      yield put(previewFileClosed());
      return;
    }

    return;
  }

  yield call(SignalingSocket.send, {
    event: 'openLibraryFile',
    data: {
      personal,
      id,
    },
  });
}
